module.exports = __webpack_public_path__ + "img/banner_cn.3180873a.png";